import { createSlice } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

const initialState = {
  byDate: {},
  allCalls: [],
};

const addToByDate = (origByDate, call) => {
  const key = DateTime.fromISO(call.date).startOf('day').toISODate();
  const oldList = origByDate[key] || [];
  const prunedList = oldList.filter((oldCall) => oldCall.callRailCallId !== call.callRailCallId);
  const newList = [...prunedList, call];
  return { ...origByDate, [key]: newList };
};

const addWithoutDuplicates = (targetList, newElements) => {
  newElements.forEach((newCall) => {
    if (!targetList.find((call) => call.callRailCallId === newCall.callRailCallId)) {
      targetList = [...targetList, newCall];
    }
  });
  return targetList;
};

export const callRailCallsSlice = createSlice({
  name: 'callRailCalls',
  initialState: initialState,
  reducers: {
    clearCrCalls: () => {
      return initialState;
    },

    addCallRailCall: (state, action) => {
      const call = action.payload;
      const allOtherCalls = state.allCalls.filter((c) => c.callRailCallId !== call.callRailCallId);
      const newAllCalls = [...allOtherCalls, call];
      const newByDate = addToByDate(state.byDate, call);
      return { ...state, byDate: newByDate, allCalls: newAllCalls };
    },

    addCallRailCallsForDates: (state, action) => {
      const datesAndCalls = action.payload;
      /*
       * this is a structure of the same form as our 'state.byDate' structure, namely:
       * {
       *    "2020-10-24": [{callRailCallId: 8, url....}, {callRailCallId: 9, url....}],
       *    "2020-10-25": [{callRailCallId: 6, url....}, {callRailCallId: 5, url....}],
       *    ...
       * }
       */
      const updatedPortionOfState = {};
      let newAllCalls = [...state.allCalls];

      const submittedKeys = Object.keys(datesAndCalls);
      submittedKeys.forEach((key) => {
        const submittedList = datesAndCalls[key];
        let oldList = state.byDate[key] || [];
        submittedList.forEach((call) => {
          oldList = oldList.filter((oldCall) => oldCall.callRailCallId !== call.callRailCallId);
        });
        const newList = [...oldList, ...submittedList];
        newAllCalls = addWithoutDuplicates(newAllCalls, submittedList);
        updatedPortionOfState[key] = newList;
      });

      const newByDate = { ...state.byDate, ...updatedPortionOfState };

      return { byDate: newByDate, allCalls: newAllCalls };
    },

    deleteCallRailCall: (state, action) => {
      const idOfCallToDelete = action.payload;
      const newAllCalls = state.allCalls.filter((call) => call.callRailCallId !== idOfCallToDelete);
      const newByDate = {};
      const datesInByDate = Object.keys(state.byDate);
      datesInByDate.foreEach((date) => {
        const origCallsForDate = state.byDate[date];
        const filteredCallsForDate = origCallsForDate.filter((call) => call.callRailCallId !== idOfCallToDelete);
        newByDate[date] = filteredCallsForDate;
      });
      return { ...state, byDate: newByDate, allCalls: newAllCalls };
    },
  },
});

export const { clearCrCalls, addCallRailCall, addCallRailCallsForDates, deleteCallRailCall } =
  callRailCallsSlice.actions;

export default callRailCallsSlice.reducer;
